export const criarConfigBuscaEmbarque = (idOrganizacao) => ({
  label: 'Embarque',
  placeholder: 'Nº Processo...',
  titulo: 'Buscar Embarque',
  endpointApi: 'Embarques',
  idField: 'numeroProcessoEmbarque',
  displayField: 'numeroProcessoEmbarque',
  descField: 'numeroDocumentoTransporte',
  tabela: 'Embarque',
  camposFiltro: [
    // { label: 'Tipo Doc. Transp.', model: 'lstTipoDocumentoTransporte', tipo: 'listabusca', tabela: 'Embarque' },
    { label: 'Doc. Transporte', model: 'numeroDocumentoTransporte', tipo: 'text' },
    { label: 'Nº Processo', model: 'numeroProcessoEmbarque', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'Nº Processo', dataField: 'numeroProcessoEmbarque', width: '20%' },
    { header: 'Tipo Doc. Transp.', dataField: 'lstTipoDocumentoTransporte', width: '15%' },
    { header: 'Doc. Transporte', dataField: 'numeroDocumentoTransporte', width: '20%' },
    { header: 'Navio', dataField: 'nomeVeiculoTransporte', width: '20%' },
    { header: 'ETD', dataField: 'dataEmbarqueETD', width: '15%' },
    { header: 'ETA', dataField: 'dataChegadaETA', width: '15%' }
  ],
  filtrosFixos: { idOrganizacao }
})
